import { Link } from 'react-router-dom'
import { useAuth } from '../contexts'

/**
 * Until now an unmatched URL rendered nothing at all - a blank page with no
 * explanation. It shows different ways home depending on whether whoever hit
 * it is signed in.
 */
export function NotFound() {
  const { user } = useAuth()

  return (
    <div className="min-h-screen bg-raven-darker flex items-center justify-center p-4">
      <div className="text-center max-w-md">
        <p className="text-6xl font-bold text-gray-700 mb-4">404</p>
        <h1 className="text-xl font-semibold text-gray-200 mb-2">This page does not exist</h1>
        <p className="text-gray-500 mb-8 text-sm">
          The link may be out of date, or the page may have been removed.
        </p>
        <Link
          to="/"
          className="inline-block border border-gray-700 hover:border-gray-500 text-gray-300 hover:text-gray-100 px-5 py-2.5 rounded-lg transition-colors"
        >
          {user ? 'Back to your profile' : 'Back to the front page'}
        </Link>
      </div>
    </div>
  )
}
